export enum IntentAction {
  NONE = 'none',
  ENTITY = 'entity',
  PLAYBACK = 'playback',
  LAUNCH = 'launch',
  HOME = 'home',
  SEARCH = 'search',
  SECTION = 'section',
}

export enum IntentSection {
  LIVE = 'live',
  MOVIES = 'movies',
  SHOWS = 'shows',
  SPORTS = 'sports',
  KIDS = 'kids',
  PROUDLY_CANADIAN = 'proudly canadian',
}
